import instance from 'utils/axios/instance.axios';
import { COUNCILS } from './_constant';

export const getAll = (councilIds, projectProposalId) =>
  instance.get(COUNCILS.GET_ALL, { params: { councilIds, projectProposalId } });

export const getById = (data) => instance.get(COUNCILS.GET_BY_ID, { params: { ...data } });

export const downloadFile = (data = {}) =>
  instance.post(COUNCILS.DOWNLOAD_FILE, data, { responseType: 'blob' });

export const getAllByProjectId = (id) => instance.get(COUNCILS.GET_ALL_BY_PROJECT_ID(id));

export const getAllCouncilTypes = () => instance.get(COUNCILS.GET_ALL_COUNCIL_TYPES);

export const getCouncilReview = (councilId, projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_REVIEW, { params: { councilId, projectProposalId } });

export const getCouncilPrequalification = (projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_PREQUALIFICATION(projectProposalId));

export const getCouncilSpecialization = (projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_SPECIALIZATION(projectProposalId));

export const getCouncilFinance = (projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_FINANCE(projectProposalId));

export const getCouncilMidterm = (projectProposalId, summaryReportId) =>
  instance.get(COUNCILS.GET_COUNCIL_MIDTERM(projectProposalId, summaryReportId));

export const getCouncilAcceptance = (projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_ACCEPTANCE(projectProposalId));

export const getCouncilLiquidation = (projectProposalId) =>
  instance.get(COUNCILS.GET_COUNCIL_LIQUIDATION(projectProposalId));
